export const EVENT_UPDATE_PANEL = "UPDATE_PANEL";
export const EVENT_UPDATE_NUTRIENTS = "UPDATE_NUTRIENTS";

export const noteMarkList = [
    { value: "1", text: "*" },
    { value: "2", text: "**" },
    { value: "3", text: "†" },
    { value: "4", text: "‡" },
    { value: "5", text: "♦" },
    { value: "6", text: "1" },
    { value: "7", text: "2" },
    { value: "8", text: "3" },
    { value: "9", text: "4" },
    { value: "10", text: "5" },
    { value: "11", text: "6" },
    { value: "12", text: "7" },
    { value: "13", text: "8" },
    { value: "14", text: "9" },
    { value: "15", text: "10" },
    { value: "16", text: "a" },
    { value: "17", text: "b" },
    { value: "18", text: "c" },
    { value: "19", text: "d" },
    { value: "20", text: "e" },
    { value: "21", text: "f" },
    { value: "22", text: "g" },
    { value: "23", text: "h" },
    { value: "24", text: "i" },
    { value: "25", text: "j" },
];

export const footnoteTemplates = [
    {
        value: "Percent Daily Values are based on a 2,000 calorie diet. Your daily values may be higher or lower depending on your calorie needs.",
        text: "DV higher/lower",
    },
    {
        value: "The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.",
        text: "Standard",
    },
    {
        value: "Not a significant source of ",
        text: "Sentence Starter",
    },
    {
        value: "% DV = %Daily Value",
        text: "Short % DV",
    },
    {
        value: "The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 1,000 calories a day is used for general nutrition advice.",
        text: "1,000 calories",
    },
    {
        value: "The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 1,000 calories a day is used for general nutrition advice for children 1-3 years.",
        text: "1,000 calories age info",
    },
    {
        value: "Contains less than 2% of the Daily Value of these nutrients.",
        text: "< 2% DV",
    },
    {
        value: "Percent Daily Values are based on a 2,000 calorie diet. Your daily values may be higher or lower depending on your calorie needs: 2,000 Calories: less than 65 g total fat; less than 20 g sat. fat; less than 300 mg cholesterol; less than 2,400 mg sodium; 300 g total carbohydrate; 25 g dietary fiber. 2,500 Calories: less than 80 g total fat; less than 25 g sat. fat; less than 300 mg cholesterol; less than 2,400 mg sodium; 375 g total carbohydrate; 30 g dietary fiber.",
        text: "Calorie Chart",
    },
];

export const DIETARY_FACTS = [
    {
        nutrient: { value: 127271, text: "Total Fat", code: "FAT" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 1,
    },
    {
        nutrient: { value: 127272, text: "Saturated Fat", code: "FASAT" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 2,
    },
    {
        nutrient: { value: 132289, text: "Trans Fat", code: "FATRN" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 3,
    },
    {
        nutrient: { value: 127273, text: "Polyunsaturated Fat", code: "FAPU" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 4,
    },
    {
        nutrient: { value: 127274, text: "Monounsaturated Fat", code: "FAMS" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 5,
    },
    {
        nutrient: { value: 127275, text: "Cholesterol", code: "CHOL-" },
        uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null },
        order: 6,
    },
    {
        nutrient: { value: 127276, text: "Sodium", code: "NA" },
        uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null },
        order: 7,
    },
    {
        nutrient: { value: 127278, text: "Total Carbohydrate", code: "CHO-" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 8,
    },
    {
        nutrient: { value: 127279, text: "Dietary Fiber", code: "FIBTSW" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 9,
    },
    {
        nutrient: { value: 127280, text: "Soluble Fiber", code: "FIBSOL" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 10,
    },
    {
        nutrient: { value: 127281, text: "Insoluble Fiber", code: "FIBINS" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 11,
    },
    {
        nutrient: { value: 152133, text: "Total Sugars", code: "SUGAR-" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 12,
    },
    {
        nutrient: { value: 140576, text: "Added Sugars", code: "SUGAD" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 13,
    },
    {
        nutrient: { value: 127283, text: "Sugar Alcohol", code: "SGRALC" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 14,
    },
    {
        nutrient: { value: 127285, text: "Protein", code: "PRO-" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 15,
    },
];

export const VITAMINERAL_FACTS = [
    { nutrient: { value: 127296, text: "Vitamin D", code: "VITD" }, uom: { value: 190135, text: "mcg", code: "mcg", tagMaskValue: 260, imageId: null } },
    { nutrient: { value: 127288, text: "Calcium", code: "CA" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
    { nutrient: { value: 127289, text: "Iron", code: "FE" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
    { nutrient: { value: 127277, text: "Potassium", code: "K" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
];

export const DIETARY_FACTS_OLD = [
    {
        nutrient: { value: 127271, text: "Total Fat", code: "FAT" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 1,
    },
    {
        nutrient: { value: 127272, text: "Saturated Fat", code: "FASAT" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 2,
    },
    {
        nutrient: { value: 132289, text: "Trans Fat", code: "FATRN" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 3,
    },
    {
        nutrient: { value: 127273, text: "Polyunsaturated Fat", code: "FAPU" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 4,
    },
    {
        nutrient: { value: 127274, text: "Monounsaturated Fat", code: "FAMS" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 5,
    },
    {
        nutrient: { value: 127275, text: "Cholesterol", code: "CHOL-" },
        uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null },
        order: 6,
    },
    {
        nutrient: { value: 127276, text: "Sodium", code: "NA" },
        uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null },
        order: 7,
    },
    {
        nutrient: { value: 127278, text: "Total Carbohydrate", code: "CHO-" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 8,
    },
    {
        nutrient: { value: 127279, text: "Dietary Fiber", code: "FIBTSW" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 9,
    },
    {
        nutrient: { value: 127280, text: "Soluble Fiber", code: "FIBSOL" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 10,
    },
    {
        nutrient: { value: 127281, text: "Insoluble Fiber", code: "FIBINS" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 11,
    },
    {
        nutrient: { value: 127282, text: "Sugars", code: "SUGARS" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 12,
    },
    {
        nutrient: { value: 127283, text: "Sugar Alcohol", code: "SGRALC" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 13,
    },
    {
        nutrient: { value: 127285, text: "Protein", code: "PRO-" },
        uom: { value: 190121, text: "g", code: "g", tagMaskValue: 256, imageId: null },
        order: 14,
    },
];

export const VITAMINERAL_FACTS_OLD = [
    { nutrient: { value: 127286, text: "Vitamin A", code: "VITA" }, uom: { value: 190153, text: "IU", code: "IU", tagMaskValue: 256, imageId: null } },
    { nutrient: { value: 127287, text: "Vitamin C", code: "VITC" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
    { nutrient: { value: 127288, text: "Calcium", code: "CA" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
    { nutrient: { value: 127289, text: "Iron", code: "FE" }, uom: { value: 190127, text: "mg", code: "mg", tagMaskValue: 256, imageId: null } },
];

export const DEFAULT_NUTRIENT_UOM = [...DIETARY_FACTS, ...VITAMINERAL_FACTS, ...DIETARY_FACTS_OLD, ...VITAMINERAL_FACTS_OLD].reduce((obj, n) => {
    if (!obj.hasOwnProperty(n.nutrient.value)) {
        obj[n.nutrient.value] = n.uom;
    }

    return obj;
}, {});
